import MenuTour from './MenuTour';

export default MenuTour;
